/* Beyond Stock — product page client JS.
   Vanilla, no deps. One IIFE per section instance. */
(function () {
  'use strict';

  function moneyFmt(cents) {
    if (cents == null) return '';
    var dollars = (cents / 100);
    // Force "$" + 2-decimal display regardless of shop currency
    var fixed = dollars.toFixed(2);
    if (fixed.endsWith('.00')) fixed = fixed.slice(0, -3);
    return '$' + fixed;
  }

  function each(list, fn) {
    Array.prototype.forEach.call(list || [], fn);
  }

  function init(root) {
    if (!root || root.__bsInit) return;
    root.__bsInit = true;

    var jsonScript = root.querySelector('[data-bs-product-json]');
    if (!jsonScript) return;
    var product;
    try { product = JSON.parse(jsonScript.textContent); }
    catch (e) { console.error('[bs-product] product JSON parse failed', e); return; }

    /* Variant-image filter prep.
       variantMediaIds = set of media ids that are tied to ANY variant
       (i.e. someone's featured_media). A media id NOT in this set is
       a "main product image" / shared shot — always visible. */
    var variantMediaIds = {};
    for (var __vi = 0; __vi < product.variants.length; __vi++) {
      var __vmid = product.variants[__vi].featured_media_id;
      if (__vmid != null) variantMediaIds[String(__vmid)] = true;
    }
    var hasVariantMedia = Object.keys(variantMediaIds).length > 0;

    var state = {
      selected: {}, // option_position -> value
      variant: null,
      qty: 1,
      galleryIndex: 0
    };

    // Seed selected from initial inputs
    each(root.querySelectorAll('[data-bs-option-input]'), function (el) {
      var pos = parseInt(el.getAttribute('data-option-position'), 10);
      if (el.type === 'radio') {
        if (el.checked) state.selected[pos] = el.value;
      } else if (el.classList.contains('is-selected')) {
        state.selected[pos] = el.getAttribute('data-value') || el.value;
      }
    });

    // Resolve current variant (selected_or_first_available_variant baseline from server)
    state.variant = resolveVariant(state.selected) || product.variants[0];

    /* ───── Variant resolution ───── */
    function resolveVariant(sel) {
      var positions = Object.keys(sel).map(Number);
      if (!positions.length) return product.variants[0];
      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var match = true;
        for (var j = 0; j < positions.length; j++) {
          var p = positions[j];
          if (v.options[p - 1] !== sel[p]) { match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }

    function setOption(position, value) {
      state.selected[position] = value;
      var matched = resolveVariant(state.selected);
      if (matched) {
        state.variant = matched;
      } else {
        state.variant = null;
      }
      reflect();
    }

    /* ───── Reflect state to DOM ───── */
    var elPrice           = root.querySelector('[data-bs-current-price]');
    var elComparePrice    = root.querySelector('[data-bs-compare-price]');
    var elVariantInput    = root.querySelector('[data-bs-variant-id-input]');
    var elAtcBtn          = root.querySelector('[data-bs-atc-button]');
    var elAtcLabel        = root.querySelector('[data-bs-atc-label]');
    var elBrandCurrent    = root.querySelector('[data-bs-brand-current]');
    var elStickyImg       = root.querySelector('[data-bs-sticky-img]');
    var elStickyPrice     = root.querySelector('[data-bs-sticky-price]');

    function reflect() {
      var v = state.variant;
      if (v) {
        if (elPrice) elPrice.textContent = moneyFmt(v.price);
        if (elComparePrice) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            elComparePrice.textContent = moneyFmt(v.compare_at_price);
            elComparePrice.style.display = '';
          } else {
            elComparePrice.style.display = 'none';
          }
        }
        if (elVariantInput) elVariantInput.value = v.id;
        if (elAtcBtn) {
          if (v.available) {
            elAtcBtn.removeAttribute('disabled');
            if (elAtcLabel) elAtcLabel.textContent = 'Buy it now';
          } else {
            elAtcBtn.setAttribute('disabled', 'disabled');
            if (elAtcLabel) elAtcLabel.textContent = 'Sold out';
          }
        }
        if (elStickyPrice) elStickyPrice.textContent = moneyFmt(v.price);
        if (elStickyImg && v.featured_image && v.featured_image.src) {
          elStickyImg.src = v.featured_image.src;
        }

        applyVariantMediaFilter(v);
      } else {
        // No matching variant
        if (elAtcBtn) {
          elAtcBtn.setAttribute('disabled', 'disabled');
          if (elAtcLabel) elAtcLabel.textContent = 'Unavailable';
        }
      }

      // Set-card UI + per-card price from live variant JSON
      var setCards = root.querySelectorAll('[data-bs-set-card]');
      var setFieldset = root.querySelector('[data-bs-set-option]');
      var setPos = setFieldset ? parseInt(setFieldset.getAttribute('data-option-position'), 10) : null;
      var brandFieldset = root.querySelector('[data-bs-brand-option]');
      var brandPos = brandFieldset ? parseInt(brandFieldset.getAttribute('data-option-position'), 10) : null;

      each(setCards, function (card) {
        var input = card.querySelector('input[type="radio"]');
        if (!input) return;
        var pos = parseInt(input.getAttribute('data-option-position'), 10);
        var thisVal = card.getAttribute('data-set-value');

        // Selection state
        if (state.selected[pos] === input.value) {
          card.classList.add('is-selected');
          input.checked = true;
        } else {
          card.classList.remove('is-selected');
          input.checked = false;
        }

        // Price for this set value, scoped to the currently selected brand if any.
        // Falls back to the cheapest variant for the value across brands.
        var priceEl = card.querySelector('[data-bs-set-current]');
        var compareEl = card.querySelector('[data-bs-set-compare]');
        if (!priceEl || setPos == null) return;

        var match = null;
        var cheapest = null;
        for (var i = 0; i < product.variants.length; i++) {
          var pv = product.variants[i];
          if (pv.options[setPos - 1] !== thisVal) continue;
          if (cheapest == null || pv.price < cheapest.price) cheapest = pv;
          if (brandPos != null && state.selected[brandPos] != null
              && pv.options[brandPos - 1] === state.selected[brandPos]) {
            match = pv;
            break;
          }
        }
        var pick = match || cheapest;
        if (pick) {
          priceEl.textContent = moneyFmt(pick.price);
          if (compareEl) {
            if (pick.compare_at_price && pick.compare_at_price > pick.price) {
              compareEl.textContent = moneyFmt(pick.compare_at_price);
              compareEl.removeAttribute('hidden');
            } else {
              compareEl.setAttribute('hidden', 'hidden');
            }
          }
        }
      });

      // Brand picker UI
      var brandPos = root.querySelector('[data-bs-brand-option]');
      if (brandPos) {
        var pos = parseInt(brandPos.getAttribute('data-option-position'), 10);
        var current = state.selected[pos];
        if (elBrandCurrent && current) elBrandCurrent.textContent = current;
        each(brandPos.querySelectorAll('.bs-brand-picker__option'), function (btn) {
          if (btn.getAttribute('data-value') === current) {
            btn.classList.add('is-selected');
          } else {
            btn.classList.remove('is-selected');
          }
        });
      }

      // Update URL ?variant=...
      if (state.variant && state.variant.id && window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', state.variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) { /* ignore */ }
      }
    }

    /* ───── Wire option inputs ───── */
    each(root.querySelectorAll('input[type="radio"][data-bs-option-input]'), function (el) {
      el.addEventListener('change', function () {
        if (!el.checked) return;
        setOption(parseInt(el.getAttribute('data-option-position'), 10), el.value);
      });
    });
    each(root.querySelectorAll('button[data-bs-option-input]'), function (btn) {
      btn.addEventListener('click', function () {
        var pos = parseInt(btn.getAttribute('data-option-position'), 10);
        var value = btn.getAttribute('data-value');
        setOption(pos, value);
        // Close the brand panel after select
        var picker = btn.closest('[data-bs-brand-picker]');
        if (picker) closeBrandPanel(picker);
        // Scroll the user back to the top of the product so they can see
        // the gallery image refresh to match the picked brand.
        scrollToProductTop();
      });
    });

    function scrollToProductTop() {
      var buybox = root.querySelector('.bs-product__buybox');
      if (!buybox) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      // Offset for any sticky header (Dawn header is ~80px tall)
      var y = buybox.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
    }

    /* ───── Brand picker behavior ───── */
    var picker = root.querySelector('[data-bs-brand-picker]');
    if (picker) {
      var trigger = picker.querySelector('[data-bs-brand-trigger]');
      var panel = picker.querySelector('[data-bs-brand-panel]');
      var search = picker.querySelector('[data-bs-brand-search]');
      var optionBtns = picker.querySelectorAll('.bs-brand-picker__option');

      function openBrandPanel() {
        panel.removeAttribute('hidden');
        picker.setAttribute('data-open', 'true');
        trigger.setAttribute('aria-expanded', 'true');
        setTimeout(function () { search && search.focus(); }, 30);
      }
      function closeBrandPanel() {
        panel.setAttribute('hidden', 'hidden');
        picker.removeAttribute('data-open');
        trigger.setAttribute('aria-expanded', 'false');
        if (search) search.value = '';
        each(optionBtns, function (b) { b.removeAttribute('hidden'); });
        var em = picker.querySelector('[data-bs-brand-empty]');
        if (em) em.setAttribute('hidden', 'hidden');
      }

      trigger.addEventListener('click', function () {
        if (picker.getAttribute('data-open') === 'true') closeBrandPanel();
        else openBrandPanel();
      });

      // Close on outside click
      document.addEventListener('click', function (e) {
        if (picker.getAttribute('data-open') !== 'true') return;
        if (!picker.contains(e.target)) closeBrandPanel();
      });

      // Close on Escape
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && picker.getAttribute('data-open') === 'true') closeBrandPanel();
      });

      // Search filter
      var emptyEl = picker.querySelector('[data-bs-brand-empty]');
      if (search) {
        search.addEventListener('input', function () {
          var q = search.value.trim().toLowerCase();
          var visible = 0;
          each(optionBtns, function (btn) {
            var v = (btn.getAttribute('data-value') || '').toLowerCase();
            if (!q || v.indexOf(q) !== -1) {
              btn.removeAttribute('hidden');
              visible++;
            } else {
              btn.setAttribute('hidden', 'hidden');
            }
          });
          if (emptyEl) {
            if (visible === 0) emptyEl.removeAttribute('hidden');
            else emptyEl.setAttribute('hidden', 'hidden');
          }
        });
      }

      // Expose for option-click closer
      // (closeBrandPanel referenced above accepts the picker arg; route through here)
      window.__bsCloseBrand = function (p) { if (p === picker) closeBrandPanel(); };
    }
    function closeBrandPanel(p) { if (window.__bsCloseBrand) window.__bsCloseBrand(p); }

    /* ───── Quantity ───── */
    var qtyInput = root.querySelector('[data-bs-qty-input]');
    var qtyHidden = root.querySelector('[data-bs-qty-hidden]');
    var qtyDec = root.querySelector('[data-bs-qty-dec]');
    var qtyInc = root.querySelector('[data-bs-qty-inc]');

    function syncQty() {
      var n = Math.max(1, parseInt(qtyInput.value, 10) || 1);
      qtyInput.value = n;
      if (qtyHidden) qtyHidden.value = n;
      state.qty = n;
    }
    if (qtyInput) {
      qtyInput.addEventListener('input', syncQty);
      qtyDec && qtyDec.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1);
        syncQty();
      });
      qtyInc && qtyInc.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
        syncQty();
      });
    }

    /* ───── Gallery ───── */
    var slides = root.querySelectorAll('[data-bs-slide]');
    var thumbs = root.querySelectorAll('[data-bs-thumb]');
    var thumbsTrack = root.querySelector('[data-bs-thumbs]');
    var prevBtn = root.querySelector('[data-bs-gallery-prev]');
    var nextBtn = root.querySelector('[data-bs-gallery-next]');

    /* Visible-only navigation: prev/next/swipe and thumb clicks cycle
       through slides not marked .is-hidden by the variant filter. */
    var visibleSlides = Array.prototype.slice.call(slides);
    function refreshVisibleSlides() {
      visibleSlides = [];
      each(slides, function (s) {
        if (!s.classList.contains('is-hidden')) visibleSlides.push(s);
      });
    }

    /* Scroll the active thumb into view inside the horizontal thumb
       strip — only when the thumb has actually fallen off either edge,
       so we don't jiggle the strip on every navigation. */
    function ensureActiveThumbVisible(thumb) {
      if (!thumb || !thumbsTrack) return;
      var trackRect = thumbsTrack.getBoundingClientRect();
      var thumbRect = thumb.getBoundingClientRect();
      var pad = 8;
      if (thumbRect.left < trackRect.left + pad) {
        thumbsTrack.scrollBy({
          left: thumbRect.left - trackRect.left - pad,
          behavior: 'smooth'
        });
      } else if (thumbRect.right > trackRect.right - pad) {
        thumbsTrack.scrollBy({
          left: thumbRect.right - trackRect.right + pad,
          behavior: 'smooth'
        });
      }
    }

    function activateSlide(slide) {
      if (!slide) return;
      var mediaId = slide.getAttribute('data-media-id');
      state.galleryIndex = Array.prototype.indexOf.call(slides, slide);
      each(slides, function (s) { s.classList.toggle('is-active', s === slide); });
      var activeThumb = null;
      each(thumbs, function (t) {
        var match = t.getAttribute('data-media-id') === mediaId;
        t.classList.toggle('is-active', match);
        if (match) activeThumb = t;
      });
      if (activeThumb) ensureActiveThumbVisible(activeThumb);
    }

    function showVisibleByOffset(delta) {
      if (visibleSlides.length === 0) return;
      var current = null;
      each(slides, function (s) { if (s.classList.contains('is-active')) current = s; });
      var idx = current ? visibleSlides.indexOf(current) : 0;
      if (idx < 0) idx = 0;
      var n = ((idx + delta) % visibleSlides.length + visibleSlides.length) % visibleSlides.length;
      activateSlide(visibleSlides[n]);
    }

    each(thumbs, function (t) {
      t.addEventListener('click', function () {
        var mid = t.getAttribute('data-media-id');
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === mid) { activateSlide(slides[i]); break; }
        }
      });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { showVisibleByOffset(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showVisibleByOffset(1); });

    // Touch swipe (mobile)
    var galleryMain = root.querySelector('.bs-gallery__main');
    if (galleryMain) {
      var startX = null;
      galleryMain.addEventListener('touchstart', function (e) {
        if (e.touches.length === 1) startX = e.touches[0].clientX;
      }, { passive: true });
      galleryMain.addEventListener('touchend', function (e) {
        if (startX == null) return;
        var endX = (e.changedTouches[0] && e.changedTouches[0].clientX) || startX;
        var dx = endX - startX;
        if (Math.abs(dx) > 40) {
          showVisibleByOffset(dx < 0 ? 1 : -1);
        }
        startX = null;
      });
    }

    /* Variant-image filter:
       - Hide slides whose media-id is the featured_media of *another*
         variant. Shared (main) product images stay visible.
       - Auto-activate the current variant's image first; if none,
         fall back to the first visible slide. */
    function applyVariantMediaFilter(v) {
      if (!hasVariantMedia) return;
      var targetId = v && v.featured_media_id != null ? String(v.featured_media_id) : null;

      function shouldShow(mediaId) {
        if (!variantMediaIds[mediaId]) return true;       // shared / main image
        return mediaId === targetId;                       // current variant only
      }

      each(slides, function (s) {
        s.classList.toggle('is-hidden', !shouldShow(s.getAttribute('data-media-id')));
      });
      each(thumbs, function (t) {
        t.classList.toggle('is-hidden', !shouldShow(t.getAttribute('data-media-id')));
      });

      refreshVisibleSlides();

      var target = null;
      if (targetId) {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].getAttribute('data-media-id') === targetId) { target = slides[i]; break; }
        }
      }
      if (!target && visibleSlides.length > 0) target = visibleSlides[0];
      if (target) activateSlide(target);
    }

    /* ───── Sticky ATC bar (mobile) ───── */
    var sticky = root.querySelector('[data-bs-sticky]');
    var stickyAddBtn = root.querySelector('[data-bs-sticky-add]');
    var atcFormBtn = root.querySelector('[data-bs-atc-button]');
    var anchor = root.querySelector('.bs-product__buybox');

    if (sticky && anchor) {
      sticky.removeAttribute('hidden');
      var visible = false;
      var ticking = false;

      function updateSticky() {
        var rect = anchor.getBoundingClientRect();
        // Only run on mobile
        var isMobile = window.matchMedia('(max-width: 749px)').matches;
        if (!isMobile) {
          if (visible) {
            sticky.classList.remove('is-visible');
            document.body.classList.remove('bs-sticky-active');
            visible = false;
          }
          ticking = false;
          return;
        }
        // Show when the bottom of the buybox has scrolled above the viewport
        var shouldShow = rect.bottom < 80;
        if (shouldShow !== visible) {
          sticky.classList.toggle('is-visible', shouldShow);
          document.body.classList.toggle('bs-sticky-active', shouldShow);
          visible = shouldShow;
        }
        ticking = false;
      }
      function onScroll() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(updateSticky);
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      updateSticky();

      if (stickyAddBtn && atcFormBtn) {
        stickyAddBtn.addEventListener('click', function () {
          atcFormBtn.click();
        });
      }
    }

    // CTA banner "back to top" scroll
    each(root.querySelectorAll('[data-bs-scroll-top]'), function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var y = (anchor || root).getBoundingClientRect().top + window.scrollY - 80;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      });
    });

    /* ───── Buy-it-now submit — adds the variant, then redirects straight to /checkout.
       This bypasses the cart drawer entirely. {%- comment %} Falls back to a plain
       form submit if fetch fails. {%- endcomment %} */
    var form = root.querySelector('[data-bs-atc-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (elAtcBtn) {
          elAtcBtn.setAttribute('disabled', 'disabled');
          if (elAtcLabel) elAtcLabel.textContent = 'Loading…';
        }
        var formData = new FormData(form);
        var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
        .then(function (r) {
          if (!r.ok) throw new Error('Add failed: ' + r.status);
          return r.json();
        })
        .then(function (data) {
          if (data && data.status && data.status >= 400) {
            throw new Error(data.description || 'Add failed');
          }
          window.location.href = '/checkout';
        })
        .catch(function (err) {
          console.error('[bs-product] buy-now error', err);
          // Plain native submit will land on /checkout via return_to.
          form.submit();
        });
      });
    }

    // Initial paint
    reflect();
  }

  function boot() {
    each(document.querySelectorAll('[data-bs-product]'), init);
    each(document.querySelectorAll('[data-bs-ugc]'), initUgc);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Re-init on Shopify section render (theme editor)
  document.addEventListener('shopify:section:load', boot);

  /* ───── UGC video slider (circular) ─────
     The original tiles live in a "middle copy" surrounded by clones
     of the same set on each side. The user always sees a left + right
     peek — even when sitting on tile 0 or tile N-1 — and when their
     scroll lands inside a clone region we silently teleport back to
     the equivalent position in the middle copy so the loop never ends.
     Dots reflect the *real* index (mod N); prev / next never disable. */
  function initUgc(strip) {
    if (!strip || strip.__bsUgcInit) return;
    strip.__bsUgcInit = true;

    var track = strip.querySelector('[data-bs-ugc-track]');
    var realTiles = Array.prototype.slice.call(strip.querySelectorAll('[data-bs-ugc-tile]'));
    var dots = strip.querySelectorAll('[data-bs-ugc-dot]');
    var prev = strip.querySelector('[data-bs-ugc-prev]');
    var next = strip.querySelector('[data-bs-ugc-next]');
    if (!track || realTiles.length === 0) return;

    var N = realTiles.length;
    /* Finite slider — no clones, no looping. Stops cleanly at both
       ends so the user can't drag past the first or last video. */
    var allTiles = realTiles.slice();

    var activeIndex = 0;
    function setActive(i) {
      if (i < 0) i = 0;
      if (i >= N) i = N - 1;
      activeIndex = i;
      each(dots, function (d, idx) { d.classList.toggle('is-active', idx === i); });
      if (prev) {
        if (i === 0) prev.setAttribute('disabled', 'disabled');
        else prev.removeAttribute('disabled');
      }
      if (next) {
        if (i === N - 1) next.setAttribute('disabled', 'disabled');
        else next.removeAttribute('disabled');
      }
    }

    /* Cached tile geometry — populated on init and on resize.
       tileCenters[i] = the scrollLeft value at which allTiles[i] is
       centered in the track. */
    var tileCenters = [];
    function measure() {
      var halfWidth = track.clientWidth / 2;
      tileCenters = [];
      for (var i = 0; i < allTiles.length; i++) {
        var t = allTiles[i];
        tileCenters[i] = t.offsetLeft + t.offsetWidth / 2 - halfWidth;
      }
    }

    function findClosestIdx() {
      var sl = track.scrollLeft;
      var bestIdx = 0, bestDist = Infinity;
      for (var i = 0; i < tileCenters.length; i++) {
        var d = Math.abs(tileCenters[i] - sl);
        if (d < bestDist) { bestDist = d; bestIdx = i; }
      }
      return bestIdx;
    }

    function scrollToIdx(idx, behavior) {
      if (idx < 0 || idx >= tileCenters.length) return;
      var target = tileCenters[idx];
      if (behavior === 'auto') {
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = target;
        track.style.scrollBehavior = '';
      } else {
        track.scrollTo({ left: target, behavior: 'smooth' });
      }
    }

    function syncActive() {
      var idx = findClosestIdx();
      if (idx !== activeIndex) setActive(idx);
    }

    // Active-dot tracking: rAF-throttled, only does scrollLeft math.
    var rafPending = false;
    track.addEventListener('scroll', function () {
      if (rafPending) return;
      rafPending = true;
      window.requestAnimationFrame(function () {
        syncActive();
        rafPending = false;
      });
    }, { passive: true });

    // Wire controls
    each(dots, function (dot) {
      dot.addEventListener('click', function () {
        var i = parseInt(dot.getAttribute('data-index'), 10);
        if (i >= 0 && i < N) scrollToIdx(i, 'smooth');
      });
    });
    if (prev) prev.addEventListener('click', function () {
      if (activeIndex > 0) scrollToIdx(activeIndex - 1, 'smooth');
    });
    if (next) next.addEventListener('click', function () {
      if (activeIndex < N - 1) scrollToIdx(activeIndex + 1, 'smooth');
    });

    // Recompute cached geometry on resize (debounced via rAF)
    var measurePending = false;
    function scheduleMeasure() {
      if (measurePending) return;
      measurePending = true;
      window.requestAnimationFrame(function () {
        measure();
        measurePending = false;
      });
    }
    window.addEventListener('resize', scheduleMeasure);
    if ('ResizeObserver' in window) {
      // Fonts loading / images decoding can change tile widths after
      // the initial measure. Recompute when the track resizes.
      var ro = new ResizeObserver(scheduleMeasure);
      ro.observe(track);
    }

    /* Play / pause videos based on visibility. */
    if ('IntersectionObserver' in window) {
      var vidObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target.querySelector('video');
          if (!v) return;
          if (entry.isIntersecting) {
            if (v.paused) {
              var p = v.play && v.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            }
          } else {
            if (!v.paused) v.pause();
          }
        });
      }, { threshold: 0.5 });
      each(realTiles, function (t) { vidObserver.observe(t); });
    }

    // Initial position: measure geometry, snap to the first tile,
    // and seed the active state (which also disables the prev button).
    function initialPosition() {
      measure();
      if (N > 0) scrollToIdx(0, 'auto');
      setActive(0);
    }
    if (document.readyState === 'complete') {
      window.requestAnimationFrame(initialPosition);
    } else {
      window.addEventListener('load', function () {
        window.requestAnimationFrame(initialPosition);
      }, { once: true });
      window.requestAnimationFrame(initialPosition);
    }
  }
})();
